import { useNavigate } from 'react-router-dom'
import CarePlanActionsList from '../components/care-plan/CarePlanActionsList'

/**
 * Standalone Care Plan route, kept for deep links. The same list is embedded
 * as the "Care Plan" tab on the Goals screen — this page is just the chrome
 * around it.
 */
export default function CarePlanActionsPage() {
  const navigate = useNavigate()

  return (
    <div className="stack">
      <button
        onClick={() => navigate('/more')}
        style={{ background: 'none', border: 'none', color: 'var(--teal)', fontWeight: 600, alignSelf: 'flex-start', padding: 0 }}
      >
        ← More
      </button>

      <div>
        <h1 className="title">Care Plan</h1>
        <p className="subtitle mt-4">Actions for each goal</p>
      </div>

      <CarePlanActionsList />

      <div style={{ height: 8 }} />
    </div>
  )
}
